export default __webpack_public_path__ + "static/media/queue.6bbbbe66.png";